import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import { TPROPERTIES_STATUS_OBJECT } from "@/src-refactor/modules/shared/model/const/realestate/property-status.const";
import styled from "@emotion/styled";
import DotIcon from "@icons-rf/property-panel/dot-small.svg?react";
import { FC } from "react";

type IPropertyStatusProps = TPROPERTIES_STATUS_OBJECT

const PropertyStatus: FC<IPropertyStatusProps> = props => {
  return (
    <Container>
      <IconStatus {...props} />
      <TextSimple color="blue" font="inter" size="label" weight="300">
        PROPIEDAD {props.name.toUpperCase()}
      </TextSimple>
    </Container>
  );
};

export default PropertyStatus;

const IconStatus: any = styled(DotIcon as any)(
  (props: TPROPERTIES_STATUS_OBJECT) => {
    return `
    width: 20px;
    height: 20px;
    color: ${props.color};
    `;
  }
);

const Container = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;
`;
